"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _SettingHorizontal = _interopRequireDefault(require("@rsuite/icon-font/lib/action/SettingHorizontal"));

// Generated by script, don't edit it please.
var SettingHorizontal = (0, _createSvgIcon["default"])({
  as: _SettingHorizontal["default"],
  ariaLabel: 'setting horizontal',
  category: 'action',
  displayName: 'SettingHorizontal'
});
var _default = SettingHorizontal;
exports["default"] = _default;
module.exports = exports.default;